import { useState, useEffect } from 'react'
import { getCompany } from '../api/companies'
import { Company } from '../types/index'

interface UseCompanyReturn {
  company: Company | null
  loading: boolean
  error: string | null
  refetch: () => Promise<void>
}

// Bug #331: this hook returned hard-coded mock data — `{ id, name: 'Sample
// Company', status: 'Active' }` after a 500ms setTimeout — and never called
// the API, even though `api/companies.ts` already exported a `getCompany`.
// Every company detail page in the platform therefore showed "Sample
// Company" with an otherwise empty overview. Identical defect and identical
// fix to `useProject` (#328); nobody had noticed because there was little
// reason to open the page until #330 started linking projects into it.
export const useCompany = (id: string): UseCompanyReturn => {
  const [company, setCompany] = useState<Company | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const fetchCompany = async () => {
    if (!id) return
    setLoading(true)
    setError(null)
    try {
      setCompany(await getCompany(id))
    } catch (err) {
      setCompany(null)
      setError(err instanceof Error ? err.message : 'Failed to load company')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    void fetchCompany()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  return { company, loading, error, refetch: fetchCompany }
}
